import React, { useState } from 'react';
import {useMutation} from "@apollo/client";
import {ADD_ALERT} from "../queries/Alerts";

function AlertForm() {
    const [routenodeId, setRoutenodeId] = useState('');
    const [status, setStatus] = useState('available');

    const [addAlert, { data, loading, error }] = useMutation(ADD_ALERT);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error {error.message}</div>;

    const handleRoutenodeIdChange = (event) => {
        setRoutenodeId(event.target.value);
    };

    const handleTypeChange = (event) => {
        setStatus(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Perform form submission logic here
        addAlert({variables: {alertsInput: {'routeNode': parseInt(routenodeId), 'status': status, 'type': 'manual'}}})
            .then(() => alert('Alert added successfully'))
        // Reset the form
        setRoutenodeId('');
        setStatus('available');
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <label htmlFor="routenodeId" className="form-label">Route Node ID:</label>
                <input
                    type="number"
                    className="form-control"
                    id="routenodeId"
                    value={routenodeId}
                    onChange={handleRoutenodeIdChange}
                />
            </div>
            <div className="mb-3">
                <label htmlFor="type" className="form-label" style={{marginRight: '10px'}}>Status:</label>
                <select id="type" className="form-select" value={status} onChange={handleTypeChange}>
                    <option value="available">Available</option>
                    <option value="broken">Broken</option>
                </select>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    );
}

export default AlertForm;
